import { Injectable } from '@angular/core';
import { ConfigServiceProxy, MaintenanceConfigDto } from '@shared/service-proxies/service-proxies';
import { DateTime } from 'luxon';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
    private config: MaintenanceConfigDto;

    constructor(private readonly configService: ConfigServiceProxy) {
    }

    load(): Observable<MaintenanceConfigDto> {
        return this.configService.getMaintenanceConfiguration()
            .pipe(tap(config => this.config = config));
    }

    isCreationDisabled(): boolean {
        return this.isInFuture(this.config?.disableApplicationCreateUntil);
    }

    isSubmissionDisabled(): boolean {
        return this.isInFuture(this.config?.disableApplicationSubmissionUntil);
    }

    private isInFuture(date: DateTime | undefined): boolean {
        return date != null && date.toMillis() > DateTime.now().toMillis();
    }
}
